import * as Boundary from "@sentry/react";
import { notification as antNotification } from "antd";

export const { ErrorBoundary } = Boundary;
export { BrowserRouter, MemoryRouter } from "react-router-dom";
export { Trans } from "react-i18next";
export const notification = antNotification;
